import { style, stylesheet, classes } from 'typestyle'

import { MAX_WIDTH } from '../../../__aeki__/modules/layouts/header'
import { Box } from '../../../__aeki__/components/box/box.component'
import { w100mdi } from '../../../__aeki__/styles/styleset/width/w100mdi'
import { w100 } from '../../../__aeki__/styles/styleset/width/w100'
import { Text } from '../../../__aeki__/components/text/text.component'

export const Images = (props: any) => {
  const { images, contain } = props

  const renderHelpText = (numberOfPic?: number, size?: number) => {
    return (
      <Box flex alignCenterX>
        <Text size="xs" baseline="surface" shrink italic>
          Click to enlarge {size && ` (Showing ${numberOfPic} of ${size})`}
        </Text>
      </Box>
    )
  }

  if (images.length == 1) {
    return (
      <Box className={classes()} maxWidth={MAX_WIDTH} centerAutoX fullWidth baseline="none" row>
        <Box column spaceBetween baseline="none">
          <Box
            className={w100}
            minHeight={360}
            baseline="none"
            onClick={async () => {
              const { Modal } = await import('../../../__aeki__/components/modal')
              await import('../../../modals/gallery')
              Modal.push({
                type: 'Gallery',
                fullWidth: true,
                fullHeight: true,
                componentProps: {
                  index: 0,
                  images,
                },
              })
            }}
          >
            <Box
              className={classes(
                contain ? STYLES.containerImage : STYLES.containerImageCover,
                style({
                  backgroundImage: `url("${images[0]}")`,
                  backgroundColor: 'rgb(250,250,250)',
                }),
              )}
              rounded
              minHeight={360}
              maxWidth={'100%'}
              baseline="none"
            />
          </Box>
        </Box>
        {renderHelpText()}
      </Box>
    )
  }

  if (images.length > 1) {
    return (
      <Box maxWidth={MAX_WIDTH} centerAutoX fullWidth baseline="none" row>
        <Box column spaceBetween baseline="none">
          <Box
            className={classes(w100mdi, style({ width: 'calc(50%)' }))}
            minHeight={360}
            baseline="none"
            onClick={async () => {
              const { Modal } = await import('../../../__aeki__/components/modal')
              await import('../../../modals/gallery')
              Modal.push({
                type: 'Gallery',
                fullWidth: true,
                fullHeight: true,
                componentProps: {
                  index: 0,
                  images,
                },
              })
            }}
          >
            <Box
              minHeight={360}
              maxWidth={'100%'}
              baseline="none"
              className={classes(
                contain ? STYLES.containerImage : STYLES.containerImageCover,
                style({
                  backgroundImage: `url("${images[0]}")`,
                  backgroundColor: 'rgb(250,250,250)',
                }),
              )}
            />
          </Box>
          <Box
            className={classes(w100mdi, style({ width: 'calc(50%)' }))}
            minHeight={360}
            baseline="none"
            onClick={async () => {
              const { Modal } = await import('../../../__aeki__/components/modal')
              await import('../../../modals/gallery')
              Modal.push({
                type: 'Gallery',
                fullWidth: true,
                fullHeight: true,
                componentProps: {
                  index: 0,
                  images,
                },
              })
            }}
          >
            <Box
              minHeight={360}
              maxWidth={'100%'}
              baseline="none"
              className={classes(
                contain ? STYLES.containerImage : STYLES.containerImageCover,
                style({
                  backgroundImage: `url("${images[1]}")`,
                  backgroundColor: 'rgb(250,250,250)',
                }),
              )}
            />
          </Box>
        </Box>
        {renderHelpText(2, images.length)}
      </Box>
    )
  }

  // if (images.length == 3) {
  //   return (
  //     <Box maxWidth={MAX_WIDTH} centerAutoX fullWidth baseline="none" row>
  //       <Box column spaceBetween baseline="none">
  //         <Box
  //           className={classes(w100mdi, style({ width: 'calc(33% - 4px)' }))}
  //           minHeight={360}
  //           baseline="none"
  //           onClick={() => {
  //             Modal.push({
  //               type: 'Gallery',
  //               fullWidth: true,
  //               fullHeight: true,
  //               componentProps: {
  //                 index: 0,
  //                 images,
  //               },
  //             })
  //           }}
  //         >
  //           <Box
  //             className={classes(
  //               contain ? STYLES.containerImage : STYLES.containerImageCover,
  //               style({ backgroundImage: `url("${images[0]}")` }),
  //             )}
  //             minHeight={360}
  //             maxWidth={'100%'}
  //             baseline="none"
  //           />
  //         </Box>
  //         <Box
  //           className={classes(w100mdi, style({ width: 'calc(33% - 4px)' }))}
  //           minHeight={360}
  //           baseline="none"
  //           onClick={() => {
  //             Modal.push({
  //               type: 'Gallery',
  //               fullWidth: true,
  //               fullHeight: true,
  //               componentProps: {
  //                 index: 0,
  //                 images,
  //               },
  //             })
  //           }}
  //         >
  //           <Box
  //             className={classes(
  //               contain ? STYLES.containerImage : STYLES.containerImageCover,
  //               style({ backgroundImage: `url("${images[1]}")` }),
  //             )}
  //             minHeight={360}
  //             maxWidth={'100%'}
  //             baseline="none"
  //           />
  //         </Box>
  //         <Box
  //           className={classes(w100mdi, style({ width: 'calc(33% - 4px)' }))}
  //           minHeight={360}
  //           baseline="none"
  //           onClick={() => {
  //             Modal.push({
  //               type: 'Gallery',
  //               fullWidth: true,
  //               fullHeight: true,
  //               componentProps: {
  //                 index: 0,
  //                 images,
  //               },
  //             })
  //           }}
  //         >
  //           <Box
  //             className={classes(
  //               contain ? STYLES.containerImage : STYLES.containerImageCover,
  //               style({ backgroundImage: `url("${images[2]}")` }),
  //             )}
  //             minHeight={360}
  //             maxWidth={'100%'}
  //             baseline="none"
  //           />
  //         </Box>
  //       </Box>
  //       {renderHelpText(3, 3)}
  //     </Box>
  //   )
  // }

  // if (images.length > 3) {
  //   return (
  //     <Box maxWidth={MAX_WIDTH} centerAutoX fullWidth baseline="none" row>
  //       <Box column spaceBetween baseline="none">
  //         <Box
  //           className={classes(w100mdi, style({ width: 'calc(50% - 4px)' }))}
  //           minHeight={360}
  //           baseline="none"
  //           onClick={() => {
  //             Modal.push({
  //               type: 'Gallery',
  //               fullWidth: true,
  //               fullHeight: true,
  //               componentProps: {
  //                 index: 0,
  //                 images,
  //               },
  //             })
  //           }}
  //         >
  //           <Box
  //             className={classes(
  //               contain ? STYLES.containerImage : STYLES.containerImageCover,
  //               style({ backgroundImage: `url("${images[0]}")` }),
  //             )}
  //             minHeight={360}
  //             maxWidth={'100%'}
  //             baseline="none"
  //           />
  //         </Box>
  //         <Box
  //           className={classes(w100mdi, style({ width: 'calc(50% - 4px)' }))}
  //           minHeight={360}
  //           baseline="none"
  //           onClick={() => {
  //             Modal.push({
  //               type: 'Gallery',
  //               fullWidth: true,
  //               fullHeight: true,
  //               componentProps: {
  //                 index: 0,
  //                 images,
  //               },
  //             })
  //           }}
  //         >
  //           <Box
  //             className={classes(
  //               contain ? STYLES.containerImage : STYLES.containerImageCover,
  //               style({ backgroundImage: `url("${images[1]}")` }),
  //             )}
  //             minHeight={360}
  //             maxWidth={'100%'}
  //             baseline="none"
  //           />
  //         </Box>
  //       </Box>
  //       {renderHelpText(2, images.length)}
  //     </Box>
  //   )
  // }

  return <div />
}

const STYLES = stylesheet({
  containerImage: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: 8,
  },
  containerImageCover: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: 8,
  },
})
